/* The collection page's filters and sort chooser.

   It lives here rather than in the section because the section's own file would otherwise be too
   large to send to the shop through the Shopify connector in one piece; it is loaded by
   sections/main-collection.liquid and is of no use anywhere else.
*/
(function () {
// ===== the filter column, live (owner, 2026-10-30) =====
// A tick applies itself; the page is NOT reloaded. The same address is fetched quietly and three
// parts are swapped in: the filters themselves (their counts change with every tick), the
// count-and-sort line, and the pieces with their pager. The address bar is set all the same, so
// the view can still be kept or shared and Back walks through the ticks. Two small courtesies:
// the column keeps the place it was scrolled to and the lists that stood open stay open, because
// nothing is more tiresome than being thrown to the top of the makers after every choice.
// Without JavaScript none of this runs and the form works by its button, exactly as before.

var wireMore = function (root) {
  for (const btn of root.querySelectorAll('.more')) {
    if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
    btn.addEventListener('click', function () {
      const rest = btn.previousElementSibling, opening = rest.hidden;
      rest.hidden = !opening;
      btn.setAttribute('aria-expanded', String(opening));
      btn.textContent = opening ? 'Show fewer' : btn.dataset.label;
    });
  }
};

// The sort chooser applies itself the moment a choice is made, so nobody has to find a button.
// Without JavaScript the form keeps its own "Sort" button and works exactly the same way - which
// is why this is a real form and not a link list.
var wireSorter = function () {
  var sorter = document.querySelector('.sorter');
  if (!sorter) return;
  sorter.classList.add('live');
  sorter.querySelector('select').addEventListener('change', function () { sorter.submit(); });
};

wireSorter();
wireMore(document);

// On a phone the groups are folded to their headings (owner, 2026-10-30, her pick of three:
// "давай первый вариант"). The block of filters was about 1 000 px tall and sat ABOVE the
// pieces, so the first piece on Necklaces was 1 160 px down - a screen and a half - and a tap
// changed only numbers the visitor could see. Folded, the whole block is six headings and the
// pieces sit directly under it. Above 760 px nothing folds: the column there is exactly as before.
//
// A group opens on a tap, and one that already holds a chosen filter opens by itself, so nothing
// applied is ever hidden. Once open it STAYS open - including across a swap, and including when
// the last tick in it is taken off - because a group closing itself under the finger is the kind
// of thing that makes a page feel haunted. Only a tap closes it.
var narrow = window.matchMedia('(max-width: 760px)');
var unfolded = {};                 // headings the visitor has opened, remembered across a swap

var fold = function () {
  var column = document.querySelector('.facets');
  if (!column) return;
  var on = narrow.matches;
  column.classList.toggle('folded', on);
  for (const group of column.querySelectorAll('.group')) {
    const head = group.querySelector('h4');
    if (!head || !group.querySelector('input[type=checkbox]')) continue;   // nothing to fold
    if (!on) {
      group.classList.remove('shut');
      head.removeAttribute('role');
      head.removeAttribute('tabindex');
      head.removeAttribute('aria-expanded');
      continue;
    }
    const name = head.textContent.trim();
    const open = unfolded[name] || !!group.querySelector('input:checked');
    if (open) unfolded[name] = true;
    group.classList.toggle('shut', !open);
    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');
    head.setAttribute('aria-expanded', String(open));
    if (head.dataset.folds) continue;
    head.dataset.folds = '1';
    const turn = function () {
      const shut = group.classList.toggle('shut');
      head.setAttribute('aria-expanded', String(!shut));
      if (shut) delete unfolded[name]; else unfolded[name] = true;
    };
    head.addEventListener('click', turn);
    head.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); turn(); }
    });
  }
};

fold();
window.addEventListener('resize', fold);

// The column is given exactly the height that is on screen (owner, 2026-10-30: "колонка не
// прокручивается до конца, нужно для этого крутить вниз страницу"). The CSS alone cannot know this:
// max-height:calc(100vh - 2rem) is right only once the column has STUCK to the top of the window,
// and until then the column begins further down the page and so hangs below the fold by that much,
// which is the part she could not reach. So the height is measured against the window instead, on
// every scroll; it grows to the full window as the column sticks. The CSS rule stays as it was,
// for a browser that never runs this. On a phone the column is not a window of its own: left alone.
(function () {
  var column = document.querySelector('.facets');
  if (!column) return;
  var wide = window.matchMedia('(min-width: 761px)');
  var fit = function () {
    if (!wide.matches) { column.style.maxHeight = ''; return; }
    var top = Math.max(column.getBoundingClientRect().top, 16);
    column.style.maxHeight = Math.max(160, window.innerHeight - top - 16) + 'px';
  };
  // Called straight from the scroll, NOT held back to the next animation frame. The frame callback
  // was tried first and left the column stuck at its loading height: a page that is not being
  // painted - a background tab, an embedded view - never runs one, and the browser already limits
  // scroll events to about one a frame. One rectangle read and one style set is cheap enough.
  fit();
  window.addEventListener('scroll', fit, { passive: true });
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();

(function () {
  var form = document.getElementById('FacetForm');
  var column = document.querySelector('.facets');
  if (!form || !column || !window.fetch || !window.DOMParser || !window.URLSearchParams) return;
  if (!form.querySelector('input[type=checkbox]')) return;
  form.classList.add('live');

  var turn = 0, walked = false;

  var opened = function () {        // which "Show more" lists stand open, named by their heading
    var names = [];
    for (const g of form.querySelectorAll('.group')) {
      var rest = g.querySelector('.rest'), head = g.querySelector('h4');
      if (rest && head && !rest.hidden) names.push(head.textContent.trim());
    }
    return names;
  };
  var reopen = function (names) {
    for (const g of form.querySelectorAll('.group')) {
      var rest = g.querySelector('.rest'), head = g.querySelector('h4'), btn = g.querySelector('.more');
      if (!rest || !head || names.indexOf(head.textContent.trim()) < 0) continue;
      rest.hidden = false;
      if (btn) { btn.setAttribute('aria-expanded', 'true'); btn.textContent = 'Show fewer'; }
    }
  };
  var swap = function (sel, doc) {
    var old = document.querySelector(sel), fresh = doc.querySelector(sel);
    if (old && fresh) old.replaceWith(fresh);
    else if (old) old.remove();
    return fresh;
  };

  var apply = function () {
    var query = new URLSearchParams(new FormData(form)).toString();
    var where = query ? form.action + '?' + query : form.action;
    var mine = ++turn;
    var held = column.scrollTop, open = opened();
    var gallery = document.querySelector('.gallery');
    if (gallery) gallery.classList.add('busy');
    column.classList.add('working');

    fetch(where, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        if (mine !== turn) return;                   // a later tick is already on its way
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('FacetForm');
        if (!fresh) throw 0;
        form.innerHTML = fresh.innerHTML;
        wireMore(form);
        reopen(open);
        fold();
        swap('.list-top', doc);
        wireSorter();
        var pieces = swap('.gallery', doc);
        var was = document.querySelector('.pager'), now = doc.querySelector('.pager');
        if (was && now) was.replaceWith(now);
        else if (was) was.remove();
        else if (now && pieces) pieces.after(now);
        column.scrollTop = held;
        column.classList.remove('working');
        history.pushState({ facets: true }, '', where);
        walked = true;
        // if the visitor had scrolled past the pieces, bring the first row back into view
        var top = document.querySelector('.list-top');
        if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ block: 'start' });
      })
      .catch(function () { form.submit(); });        // anything unexpected: the plain form, as before
  };

  form.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'checkbox') apply();
  });
  window.addEventListener('popstate', function () { if (walked) location.reload(); });
})();
})();